import { Icon } from '@chakra-ui/react';

export default function StatusUncheduledIcon(props) {
  return (
    <Icon
      width='20px'
      height='20px'
      viewBox='0 0 20 20'
      fill='none'
      color='surface.outline'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_11043_67229)'>
        <path
          d='M17.5 10.625C17.182 14.475 13.932 17.5 10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10C2.5 6.06797 5.525 2.81797 9.375 2.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 5.625V10H14.375'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.5 3.59375C12.9315 3.59375 13.2812 3.24397 13.2812 2.8125C13.2812 2.38103 12.9315 2.03125 12.5 2.03125C12.0685 2.03125 11.7188 2.38103 11.7188 2.8125C11.7188 3.24397 12.0685 3.59375 12.5 3.59375Z'
          fill='currentColor'
        />
        <path
          d='M15.3125 5.46875C15.744 5.46875 16.0938 5.11897 16.0938 4.6875C16.0938 4.25603 15.744 3.90625 15.3125 3.90625C14.881 3.90625 14.5312 4.25603 14.5312 4.6875C14.5312 5.11897 14.881 5.46875 15.3125 5.46875Z'
          fill='currentColor'
        />
        <path
          d='M17.1875 8.28125C17.619 8.28125 17.9688 7.93147 17.9688 7.5C17.9688 7.06853 17.619 6.71875 17.1875 6.71875C16.756 6.71875 16.4062 7.06853 16.4062 7.5C16.4062 7.93147 16.756 8.28125 17.1875 8.28125Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_11043_67229'>
          <rect
            width='20'
            height='20'
            rx='10'
            fill='white'
          />
        </clipPath>
      </defs>
    </Icon>
  );
}
